import type { FunctionComponentWithRef } from "react";
import { graphql, useFragment } from "react-relay";
import type { ShareButtonProps } from "scmp-sdk";

import type { popupArticle20ShareMenuContent$key } from "scmp-app/queries/__generated__/popupArticle20ShareMenuContent.graphql";

import { Header, StyledArticleShareWidget, StyledPaper } from "./styles";

export type Props = Pick<ShareButtonProps, "position"> & {
  className?: string;
  reference: popupArticle20ShareMenuContent$key;
  variant?: "video-short";
};

export const Article20ShareMenuPopup: FunctionComponentWithRef<Props, HTMLDivElement> = ({
  className,
  position,
  ref,
  reference,
  variant,
}) => {
  const content = useFragment(
    graphql`
      fragment popupArticle20ShareMenuContent on Content {
        ...articleShareWidgetArticle
      }
    `,
    reference,
  );

  return (
    <StyledPaper $variant={variant} className={className} ref={ref}>
      <Header>Share</Header>
      <StyledArticleShareWidget
        $variant={variant}
        position={position}
        reference={content}
        variant={variant}
      />
    </StyledPaper>
  );
};

Article20ShareMenuPopup.displayName = "Article20ShareMenuPopup";
